import React, { useState } from 'react';
import { useMessageGetter } from '@messageformat/react';
import { Action, Locale } from '@op/opds.opux';

import { useCardLanguage } from '../../context/CardLanguageContext';

const LanguageOption: React.FC<{
    language: Locale;
    setLiveMessage: any;
}> = ({ language, setLiveMessage }) => {
    const cardLanguageState = useCardLanguage();
    const selected = cardLanguageState?.language === language;
    const messageGetter = useMessageGetter([]);

    const handleLanguageSelection = () => {
        // Save selected language to local storage
        localStorage.setItem('language', language);
        cardLanguageState?.setLanguage(language);

        // Set html language to selection
        document.documentElement.lang = language;
        // Set live message for screen readers
        setLiveMessage(messageGetter(`Phrase_Language_Changed_${language}`));
    };

    return (
        <Action
            button
            nonInteractive={selected}
            aria-label={messageGetter(`Phrase_Choose_Language_${language}`)}
            onClick={handleLanguageSelection}
            className={!selected ? 'not-selected' : 'selected'}
            tabIndex={selected ? -1 : 0}
            aria-current={selected}
            lang={language}
            inline>
            {language.toUpperCase()}
        </Action>
    );
};

const LanguageSelection: React.FC<{}> = () => {
    const [liveMessage, setLiveMessage] = useState('');

    return (
        <div className='ec-wrapping'>
            <LanguageOption language={'fi'} setLiveMessage={setLiveMessage} />
            <span className='ec-margins'>
                <LanguageOption
                    language={'en'}
                    setLiveMessage={setLiveMessage}
                />
            </span>
            <LanguageOption language={'sv'} setLiveMessage={setLiveMessage} />
            <div aria-live='polite' className='visually-hidden'>
                {liveMessage}
            </div>
        </div>
    );
};

LanguageSelection.displayName = 'LanguageSelection';
export default LanguageSelection;
